// Chakra imports
import { Box, Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';
import Footer from 'components/footer/FooterAuth';
import { NavLink } from 'react-router-dom';

function AuthIllustration(props) {
  const { children } = props;
  return (
    <Flex position='relative' h='max-content'>
      <Flex
        h={{
          sm: 'initial',
          md: 'unset',
          lg: '100vh',
          xl: '97vh',
        }}
        w='100%'
        maxW={{ md: '66%', lg: '1313px' }}
        mx='auto'
        pt={{ sm: '50px', md: '0px' }}
        px={{ lg: '30px', xl: '0px' }}
        ps={{ xl: '70px' }}
        justifyContent='start'
        direction='column'
      >
        <NavLink
          to='/admin'
          style={() => ({
            width: 'fit-content',
            marginTop: '40px',
          })}
        >
          <Flex
            align='center'
            ps={{ base: '25px', lg: '0px' }}
            pt={{ lg: '0px', xl: '0px' }}
            w='fit-content'
          ></Flex>
        </NavLink>
        {children}
        <Box
          display={{ base: 'none', md: 'block' }}
          h='100%'
          // minH="100vh"
          w={{ md: '40vw', lg: '50vw', '2xl': '44vw' }}
          position='absolute'
          right='0px'
        >
          <Flex
            // bg={`url(${illustrationBackground})`}
            justify='center'
            align='center'
            justifyContent='center'
            w='50%'
            h='30%'
            bgSize='cover'
            position='absolute'
            margin='auto'
            paddingRight={10}
            // borderBottomLeftRadius={{ lg: "120px", xl: "200px" }}
          ></Flex>
        </Box>
        <Footer />
      </Flex>
    </Flex>
  );
}

AuthIllustration.propTypes = {
  illustrationBackground: PropTypes.string,
  image: PropTypes.any,
};

export default AuthIllustration;
